import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
} from '@mui/material'

declare module '@mui/material/Table' {
  interface TablePropsVariantOverrides {
    plain: true
  }

  interface TableOwnProps {
    variant?: 'plain' | 'default'
  }
}

export interface MuiTableData {
  defaultProps?: ComponentsProps['MuiTable']
  styleOverrides?: ComponentsOverrides['MuiTable']
  variants?: ComponentsVariants['MuiTable']
}

export const MuiTable: MuiTableData = {
  styleOverrides: {
    root: {},
  },
  variants: [
    {
      props: { variant: 'default' },
      style: {
        minWidth: 650,
        borderCollapse: 'separate',
        borderSpacing: '0 8px',
        p: 1,
        '& .MuiTableCell-root': {
          minWidth: { xs: '75px', xxxl: 'none' },
          paddingLeft: '12px',
          paddingRight: '12px',
          paddingTop: '10px',
          paddingBottom: '10px',
          '@media (max-width: 1700px)': {
            paddingRight: '12px',
            paddingLeft: '12px',
          },
        },
      },
    },
    {
      props: { variant: 'plain' },
      style: {},
    },
  ],
}
